export default "__VITE_ASSET__83fa5b2a__"